import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ValidationService {

    constructor() { }

    static emailValidator(control) {
        // RFC 2822 compliant regex
        var reg = /^[a-zA-Z0-9._]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (control.value.match(reg)) {
            return null;
        } else {
            return { 'invalidEmailAddress': true };
        }
    }

    static numberValidator(control) {
        // RFC 2822 compliant regex
        if (control.value.match(/\b(\d+)\b/g)) {
            return null;
        } else {
            return { 'invalidContactNumber': true };
        }
    }

    static NoWhitespaceValidator(control) {
        let isWhitespace = (control.value || '').trim().length === 0;
        let isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true }
    }


}
